import React from 'react';
import T from 'i18n-react';
import { makeContainerStyles } from '../../styles';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { ProgressButton } from '../../../core/Button';
import { PASSWORD_PATTERN } from '../../../core/variables';
import TextField from '../../../core/FormField/TextField';

const useStyles = makeStyles((theme) => ({
  container: {
    ...makeContainerStyles(theme),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: 'bold',
    margin: theme.spacing(0, 'auto', 4),
  },
  email: {
    margin: theme.spacing(0, 'auto', 2),
    maxWidth: 400,
  },
  password: {
    margin: theme.spacing(0, 'auto', 1),
    maxWidth: 400,
  },
  passwordConfirm: {
    margin: theme.spacing(0, 'auto', 4),
    maxWidth: 400,
  },
  buttonContainer: {
    width: '100%',
    maxWidth: 300,
    '& > *': {
      width: '100%',
      maxWidth: 300,
    },
  },
  button: {
    fontWeight: 'bold',
    fontSize: theme.typography.pxToRem(14),
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(16),
    },
  },
}));

const EmailSignUpForm = () => {
  const classes = useStyles();
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [passwordConfirm, setPasswordConfirm] = React.useState('');
  const [isRequesting] = React.useState(false);

  return (
    <div className={classes.container}>
      <Typography className={classes.title}>
        {T.translate('user.signup.title')}
      </Typography>
      <TextField
        label={T.translate('email')}
        variant="outlined"
        required
        type="email"
        disabled={isRequesting}
        className={classes.email}
        fullWidth
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <TextField
        label={T.translate('user.signup.password')}
        helperText={T.translate('user.signup.passwordHelperText')}
        variant="outlined"
        required
        type="password"
        disabled={isRequesting}
        className={classes.password}
        fullWidth
        inputProps={{ pattern: PASSWORD_PATTERN }}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <TextField
        label={T.translate('user.signup.passwordConfirm')}
        variant="outlined"
        required
        type="password"
        disabled={isRequesting}
        className={classes.passwordConfirm}
        fullWidth
        inputProps={{ pattern: PASSWORD_PATTERN }}
        value={passwordConfirm}
        onChange={(e) => setPasswordConfirm(e.target.value)}
      />
      <div className={classes.buttonContainer}>
        <ProgressButton
          variant="contained"
          color="primary"
          disabled={isRequesting}
          progress={isRequesting}
          className={classes.button}
          fullWidth
        >
          {T.translate('register')}
        </ProgressButton>
      </div>
    </div>
  );
};

export default EmailSignUpForm;
